import { Facebook, LinkedIn, Twitter } from "@mui/icons-material";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start">
            <p className="mb-0">© {new Date().getFullYear()} GTEN Technologies. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <a href="https://twitter.com/x/migrate?tok=7b2265223a222f6774656e746563686e6f6c6f6779222c2274223a313733383636363234367d95070bf485348a21a70f0ee7060db738" className="social-icon mx-2" aria-label="Twitter">
              <Twitter />
            </a>
            <a href="https://www.facebook.com/GTENTechnologies/" className="social-icon mx-2" aria-label="Facebook">
              <Facebook />
            </a>
            <a href="https://www.linkedin.com/company/gtentechnologies" className="social-icon mx-2" aria-label="LinkedIn">
              <LinkedIn />
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
